import {
  HYDRATE_ACTIVE_CONTEXT,
  SWITCH_CONTEXT,
  SWITCH_CONTEXT_SUCCESS,
  SWITCH_CONTEXT_FAIL,
  CLEAR_ACTIVE_CONTEXT_ERROR,
  REFRESH_AGGREGATE_VIEW_ORGS,
  REFRESH_ACTIVE_CONTEXT,
  REFRESH_ACTIVE_CONTEXT_SUCCESS,
  REFRESH_ACTIVE_CONTEXT_FAIL,
} from './actionTypes';

export const hydrateActiveContext = () => ({ type: HYDRATE_ACTIVE_CONTEXT });

/**
 * Request a context switch.
 *
 * @param {number|null} organizationId  target org id, or null to switch to Global View
 * @param {(target: string) => void} [onSuccess]  navigation callback fired after the
 *   saga persists the reissued JWT; receives the target path to navigate to.
 */
export const switchContext = (organizationId, onSuccess) => ({
  type: SWITCH_CONTEXT,
  payload: { organizationId, onSuccess },
});

export const switchContextSuccess = (data) => ({
  type: SWITCH_CONTEXT_SUCCESS,
  payload: data,
});

export const switchContextFail = (error) => ({
  type: SWITCH_CONTEXT_FAIL,
  payload: error,
});

export const clearActiveContextError = () => ({ type: CLEAR_ACTIVE_CONTEXT_ERROR });

/**
 * Reconcile memberships[].hasAggregateView against the live set of org IDs
 * returned by GET /global/sub-organizations. Dispatched by the Global pages
 * after a successful fetch so the sidebar's "(N orgs)" count reflects the
 * caller's current permissions without waiting for a re-login.
 */
export const refreshAggregateViewOrgs = (aggregateOrgIds) => ({
  type: REFRESH_AGGREGATE_VIEW_ORGS,
  payload: { aggregateOrgIds: Array.isArray(aggregateOrgIds) ? aggregateOrgIds : [] },
});

/**
 * Pull the full active-context envelope from the backend. Dispatched on tab
 * focus and when the org switcher opens so users see new memberships and
 * permission changes without needing to log out. The saga throttles repeat
 * calls so multiple triggers in quick succession only hit the server once.
 */
export const refreshActiveContext = () => ({ type: REFRESH_ACTIVE_CONTEXT });

export const refreshActiveContextSuccess = (payload) => ({
  type: REFRESH_ACTIVE_CONTEXT_SUCCESS,
  payload,
});

export const refreshActiveContextFail = (error) => ({
  type: REFRESH_ACTIVE_CONTEXT_FAIL,
  payload: error,
});
